module.exports = __webpack_public_path__ + "img/rzLogo.c90668aa.png";